import { Injectable } from '@angular/core';

import { OralDeposition } from '../../models/oral-deposition';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class OralDepositionService {
  private url: string = 'oral_depositions';

  constructor(private httpClient: HttpClientService) {}

  acceptanceUpdate(oral_deposition_id: number, oral_deposition_event_id: number, oral_deposition_accept_id: number, accepted: boolean): Promise<any> {
    return this.httpClient.put(`${this.url}/${oral_deposition_id}.json`, { accept_update: true, oral_deposition_accept_id: oral_deposition_accept_id, oral_deposition_event_id: oral_deposition_event_id, accepted: accepted });
  }

  cancelOralDeposition(oral_deposition_id: number): Promise<any> {
    return this.httpClient.put(`${this.url}/${oral_deposition_id}.json`, { cancel: true });
  }

  cancelHoldEvent(oral_deposition_event_id: number, oral_deposition_id: number): Promise<any> {
    return this.httpClient.put(`${this.url}/${oral_deposition_id}.json`, { oral_deposition_event_id: oral_deposition_event_id, cancel_hold_event: true });
  }

  deleteNote(matter_history_id: number, oral_deposition_id: number): Promise<any> {
    return this.httpClient.put(`${this.url}/${oral_deposition_id}.json`, { matter_history_id: matter_history_id, delete_note: true });
  }

  deleteEvent(oral_deposition_event_id: number, oral_deposition_id: number): Promise<any> {
    return this.httpClient.put(`${this.url}/${oral_deposition_id}.json`, { oral_deposition_event_id: oral_deposition_event_id, delete_proposed_event: true });
  }

  edit(id: number, params: any = {}) {
    return this.httpClient.get(`${this.url}/${id}/edit.json`, params);
  }

  emailNote(matter_history_id: number, oral_deposition_id: number): Promise<any> {
    return this.httpClient.put(`${this.url}/${oral_deposition_id}.json`, { matter_history_id: matter_history_id, email_note: true });
  }

  formOptions(matter_id: number | null = null): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { form_options: true, matter_id: matter_id });
  }

  get(id: number, params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}.json`, params);
  }

  holdEvent(oral_deposition_event_id: number, oral_deposition_id: number): Promise<any> {
    return this.httpClient.put(`${this.url}/${oral_deposition_id}.json`, { oral_deposition_event_id: oral_deposition_event_id, hold_event: true });
  }

  index(params: any = {}) {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  rescheduleEvent(oral_deposition_id: number): Promise<any> {
    return this.httpClient.put(`${this.url}/${oral_deposition_id}.json`, { reschedule: true });
  }

  searchOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { search_options: true });
  }

  save(oralDeposition: OralDeposition, participants: Array<any>): Promise<any> {
    if (oralDeposition.id) return this.httpClient.put(`${this.url}/${oralDeposition.id}.json`, { oral_deposition: oralDeposition, oral_deposition_participants: participants });
    else return this.httpClient.post(`${this.url}.json`, { oral_deposition: oralDeposition, oral_deposition_participants: participants });
  }

  saveEvent(oralDepositionEvent: any, oralDepositionId: number): Promise<any> {
    return this.httpClient.put(`${this.url}/${oralDepositionId}.json`, { oral_deposition_event: oralDepositionEvent, save_proposed_event: true });
  }

  saveNote(note: string, matter_history_id: number | undefined, oral_deposition_id: number): Promise<any> {
    if (matter_history_id) return this.httpClient.put(`${this.url}/${oral_deposition_id}.json`, { note: note, matter_history_id: matter_history_id, update_note: true });
    else return this.httpClient.put(`${this.url}/${oral_deposition_id}.json`, { note: note, create_note: true });
  }

  scheduleEvent(oral_deposition_event_id: number, oral_deposition_id: number): Promise<any> {
    return this.httpClient.put(`${this.url}/${oral_deposition_id}.json`, { oral_deposition_event_id: oral_deposition_event_id, schedule_event: true });
  }
}
